<template>
  <base-section id="suretyship" space="5">
    <v-container fluid>
      <v-card outlined>
        <v-tabs
          v-model="tab"
          background-color="secondary"
          centered
          dark
          icons-and-text
          dense
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1">
            CERTIFICATE
            <v-icon>mdi-certificate-outline</v-icon>
          </v-tab>
          <v-tab href="#tab-2">
            CLAIM
            <v-icon>mdi-security</v-icon>
          </v-tab>
          <v-tab href="#tab-3">
            SUBROGATION
            <v-icon>mdi-cash-refund</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <template>
              <v-tabs v-model="tab2">
                <v-tab href="#tab-create"
                  ><v-icon left> mdi-database-check </v-icon> Create</v-tab
                >
                <v-tab href="#tab-list"
                  ><v-icon left> mdi-database-search-outline </v-icon>
                  List</v-tab
                >
              </v-tabs>
              <v-tabs-items v-model="tab2">
                <v-tab-item value="tab-create">
                  <app-surety-create
                    @response="switchToListTab"
                  ></app-surety-create>
                </v-tab-item>
                <v-tab-item value="tab-list">
                  <app-surety-inqury
                    :fastflow_id="fastflow_id"
                  ></app-surety-inqury>
                </v-tab-item>
              </v-tabs-items>
            </template>
          </v-tab-item>
          <v-tab-item value="tab-2"> </v-tab-item>
          <v-tab-item value="tab-3"> </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SuretyShipDashboard",
  data: () => ({
    tab: null,
    tab2: null,
    fastflow_id: ""
  }),
  methods: {
    switchToListTab(response) {
      console.log(response);
      this.fastflow_id = response.fastflow_id;
      this.tab2 = "tab-list";
    }
  }
};
</script>
